var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.personConfig.title,
        visible: _vm.dialogFormVisible,
        width: "500px",
        modal: false,
        "close-on-click-modal": false,
        "custom-class": "person",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogFormVisible = $event
        },
      },
    },
    [
      _vm.personConfig.type == 2
        ? _c("div", [
            _c(
              "div",
              { staticClass: "updata" },
              [
                _c("div", { staticClass: "name mb15" }, [
                  _vm._v(_vm._s(_vm.excelFail.name)),
                ]),
                _vm._v(" "),
                _c(
                  "el-upload",
                  {
                    staticClass: "upload-demo mb10",
                    attrs: {
                      action: _vm.fileUrl,
                      "on-success": _vm.handleSuccess,
                      headers: _vm.myHeaders,
                      "show-file-list": false,
                      data: _vm.uploadData,
                      multiple: "",
                      accept: ".xls,.xlsx",
                      "before-upload": _vm.beforeUpload,
                    },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          slot: "trigger",
                          size: "small",
                          type: "primary",
                        },
                        slot: "trigger",
                      },
                      [_vm._v(_vm._s(_vm.$t("public.selectfile")))]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { slot: "trigger", size: "small", type: "text" },
                        on: { click: _vm.handleDownLoad },
                        slot: "trigger",
                      },
                      [_vm._v(_vm._s(_vm.$t("public.down")))]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c("el-button", { on: { click: _vm.close } }, [
                  _vm._v(_vm._s(_vm.$t("public.cancel"))),
                ]),
                _vm._v(" "),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.determine } },
                  [_vm._v(_vm._s(_vm.$t("public.ok")))]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }